/**
 *
 * .sticky_top
 */
var ProgressBar = require('progressbar.js');

var scrollLimit = 400,
    scrollcheck_interval = 500,
    interior_menu = 420,
    bottom_offset = 400,
    _scroll_offset = 80,
    didScroll = false,
    sticky_top_offset = 0;
    previous = 0; // scroll limit

module.exports = {
  init: function($) {
    'use strict';

    /*
     * assign 'scrolled' class when the user scrolls more than scroll limit
     */
    var _scrolled = function () {
        var _document_scrolltop = $(document).scrollTop();

        // Check if the person has scrolled
        if( _document_scrolltop > scrollLimit ) {
                $('body').addClass('scrolled');
                // scroll direction
                if( previous > _document_scrolltop ) {
                  //Scrolled Up
                  $('body').addClass('scrolledup');
                } else {
                  $('body').removeClass('scrolledup');
                }
                previous = _document_scrolltop;
            } else {
                $('body').removeClass('scrolled');
            }
            
        // Check for the interior menu scroll offset
        if( _document_scrolltop > interior_menu ) {
          $('body').addClass('interior_menu_stick');
        } else {
          $('body').removeClass('interior_menu_stick');
        }

        // Check if the user scrolled to the near bottom
        if(_document_scrolltop + $(window).outerHeight() > $(document).outerHeight() - bottom_offset) {
           $('body').addClass('at-the-bottom');
            } else {
            $('body').removeClass('at-the-bottom');
        }

    // Check if element has hit the top
    $('.check_in_screen').each( function() {
          var $this = $(this);
          // Make it sure to use 'position()' instead of offset() since, the element will be fixed which will lost offset value with the class
          if ( $(window).scrollTop() + ( $(window).height() / 2 ) >= $this.offset().top ) {
              $this.addClass('in_screen');
          } else {
              $this.removeClass('in_screen');
          }
      });

    // run progression circle
    $('.frontpage_video_works').each( function() {
          var $this = $(this);
          // Make it sure to use 'position()' instead of offset() since, the element will be fixed which will lost offset value with the class
          if ( $(window).width() <= 790 || $(window).scrollTop() + ( $(window).height() / 2 ) >= $this.position().top ) {
              if( !$this.hasClass('in_screen') ) {
                $this.addClass('in_screen');
                // Run the circle animation
                $('.video_work_item').each(function() {
                  var $this = $(this);
                  var bar = new ProgressBar.Circle('.video_work_item.index_'+$this.data('index')+'>.circle', {
                      color: '#aaa',
                      // This has to be the same size as the maximum width to
                      // prevent clipping
                      strokeWidth: 20,
                      trailWidth: 20,
                      easing: 'easeInOut',
                      duration: 1400,
                      text: {
                        autoStyleContainer: false
                      },
                      from: { color: 'rgb(77, 78, 80)', width: 20 },
                      to: { color: '#88944a', width: 20 },
                      // Set default step function for all animate calls
                      step: function(state, circle) {
                        circle.path.setAttribute('stroke', state.color);
                        circle.path.setAttribute('stroke-width', state.width);

                        var value = Math.round(circle.value() * 100);
                        if (value === 0) {
                          circle.setText('');
                        } else {
                          circle.setText(value + '%');
                        }

                      }
                    });
                    bar.text.style.fontFamily = 'roboto-condensed,sans-serif';
                    bar.text.style.fontSize = '2.4rem';
                    bar.text.style.color = 'white';
                    // Number from 0.0 to 1.0
                    // bar.animate(1.0); 
                    bar.animate( $(this).data('pct') / 100 );
                });
              }
          }
            if( $(window).width() <= 790 ) {
                if( !$('.video_work_item_container').hasClass('slick-initialized') ) {
                    $('.video_work_item_container').slick();
                }
            } else {
                if($('.video_work_item_container').hasClass('slick-initialized') ) {
                    $('.video_work_item_container').slick('unslick');
                }
            }
      });


    // Scroll to 

    // Check if element has hit the top
    $('.sticky_top').each( function() {
          var $this = $(this);
          // console.log($(window).scrollTop() + sticky_top_offset+':'+$this.position().top);
          // Make it sure to use 'position()' instead of offset() since, the element will be fixed which will lost offset value with the class
          if ( $(window).scrollTop() + sticky_top_offset >= $this.position().top ) {
              $this.addClass('sticked');
          } else {
              $this.removeClass('sticked');
          }
        });
    };

    $('.scrolltoprimary, #slider_logo').on('click',function(e) {
        e.preventDefault();
        $('body,html').animate({scrollTop:$('#primary').offset().top-64});
    });

    $('a.goto_onthispage').on('click', function(e) {
      e.preventDefault();
      var _scroll_to = 0;
      _scroll_to = $( $(this).attr('href') ).offset().top;
      _scroll_to -= _scroll_offset;
      $('html, body').animate({
              scrollTop: _scroll_to + 'px'
          }, 'fast');
    });

    $('.open_inqury_container_mobile').on('click',function(e) {
       e.preventDefault();
      var _scroll_to = 0;
      _scroll_to = $( $(this).attr('href') ).position().top;
      _scroll_to -= _scroll_offset;
      $('#primary-menu-container').animate({
              scrollTop: _scroll_to + 'px'
          }, 'fast');
    });
    $(window).load(function() {
      _scrolled(); // Check once in the beginning
    });

    $(window).on('scroll', function() {
        didScroll = true;
    });

    setInterval(function() {
        if ( didScroll ) {
            didScroll = false;
            _scrolled();
        }
    }, scrollcheck_interval );

  }
};
